import {
	applySnapshot, flow, Instance, types, getParent,
} from 'mobx-state-tree';

import {
	getServices,
} from '@common/api/services';

import Service from './Service';
import { getCurrentServiceId, saveCurrentServiceId } from './storage';

const Services = types
	.model('Services', {
		data: types.optional(types.array(Service), []),
		current_selected: types.optional(types.reference(Service), getCurrentServiceId()),
		// @TODO: Refactor after hotfix
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get current() {
			// @ts-ignore
			return getParent(self).profile.services
				.find((service: any) => service.id === self.current_selected.id)
				// @ts-ignore
				|| getParent(self).profile.services[0];
		},
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getServices();
				applySnapshot(self.data, result);
			} finally {
				self.loading = false;
			}
		}),
		select(serviceId: number) { // @TODO: Check why TS in not working with reference
			// @ts-ignore-next-line
			self.current_selected = serviceId;
			saveCurrentServiceId(serviceId);
		},
	}));

export default Services;

export interface IServicesModel extends Instance<typeof Services> {}
